<template>
    <div>
        <FullPageLoader :isLoading="loading"/>

        <ContractsRecordProducts
            ref="ContractsRecordProducts_products"
            type="products"
            @passProducts="passProducts"
            :onlyModal="true"
            mode="new"
            :record="record"
        />

        <!-- Discount Modal -->
        <discount-modal
            :is-open="showDiscountModal"
            :product-price="currentProductPrice"
            :existing-discounts="currentProductDiscounts"
            :single-invoice-mode="true"
            @close="showDiscountModal = false"
            @apply="applyDiscount"
            @remove="removeDiscount"
        />

        <div class="row">
            <div class="column medium-4 text-right float-right">
                <!-- <b-button v-if="mode == 'new'" type="is-light">
                    <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left">
                        <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :disabled="!_.isNull(record.step2.customer_id) && activeStep == 1" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                    </b-tooltip>
                </b-button> -->

                <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left">
                    <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                </b-tooltip>
                <b-button tag="router-link" to="/panel/creditfacturen/" type="is-dark">Terug naar overzicht</b-button>
            </div>
            <div class="column medium-8">
                <h1>{{ type == 'credit' ? 'Creditfactuur' : 'Factuur' }} aanmaken</h1>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <form class="form">
                    <b-tabs size="is-medium" class="block" v-model="activeStep">
                        <b-tab-item label="Klant" :visible="!hideCustomerTab">
                            <div class="column small-7" style="padding-left:0;">
                                <h1 class="title">Klant {{ record.customer_id ? 'gekoppeld' : 'aanmaken' }}</h1>
                            </div>

                            <div v-show="record.customer_id">
                                <CRUDCustomer
                                    ref="CRUDcustomer"
                                    :id="record.customer_id"
                                    :getCustomer="record.customer || {}"
                                    :record="record"
                                    :canRemoveCustomer="mode == 'new'"
                                    embedded_from="CreateInvoiceRecord"
                                    @removeCustomer="removeCustomer"
                                    :showAlert="true"
                                    @fullPageLoader="fullPageLoader"
                                    @linkCustomer="linkCustomer"
                                />
                            </div>
                            <div v-show="!record.customer_id">
                                <FindCustomer
                                    ref="findCustomer"
                                    :showAllCustomers="record.customer_id ? false : true"
                                    @linkCustomer="linkCustomer"
                                />
                            </div>
                        </b-tab-item>

                        <b-tab-item label="Algemeen" :key="updateKey">
                            <!-- <div v-if="user && user.role == 'pit' && mode == 'new'">
                                <b-field label="Organisatie (PIT)"
                                    :message="getError(errors, 'organisation')"
                                    :type="getType(errors, 'organisation', '')"
                                >
                                    <span>
                                        <b-select placeholder="Selecteer een organisatie" v-model="record.organisation" expanded>
                                            <option
                                                v-for="organisation in organisations"
                                                :value="organisation.id"
                                                :key="'organisatie_'+organisation.id"
                                                :disabled="organisation.invited === 0"
                                            >(ID: {{ organisation.id }}) {{ organisation.name }}{{ organisation.invited == 0 ? ' - Organisatie niet uitgenodigd!' : '' }}</option>
                                        </b-select>
                                    </span>
                                </b-field>
                                <br>
                            </div> -->

                            <b-message title="Creditfactuur versturen" type="is-info" aria-close-label="Sluiten" v-if="type == 'credit'">
                                <!-- New message here <3 -->
                            </b-message>

                            <div v-show="type != 'credit'">
                                <h5>Algemeen</h5>
                            </div>

                            <div v-if="user.organisation_locations && user.organisation_locations.length > 1" class="field">
                                <b-field label="Vestiging"
                                    :message="getError(errors, 'location')"
                                    :type="getType(errors, 'location', '')"
                                >
                                    <b-select placeholder="Selecteer een vestiging" v-model="record.location" expanded>
                                        <option v-for="location in user.organisation_locations" :value="location.id">{{ location.name }} {{ location.city ? `- ${location.city}` : '' }}</option>
                                    </b-select>
                                </b-field>
                            </div>

                            <div v-if="type == 'invoice'">
                                <b-field label="Betaalmethode"
                                    :message="getError(errors, 'payment_type')"
                                    :type="getType(errors, 'payment_type', '')"
                                >
                                    <b-select placeholder="Maak een keuze" v-model="record.payment_type" expanded>
                                        <option value="incasso" :disabled="!user['organisation_incasso']">Automatische incasso{{ $store.state.env == 'demo' ? ' (uitgeschakeld in demo-omgeving)' : '' }}</option>
                                        <option value="manual">Handmatig</option>
                                    </b-select>
                                </b-field>

                                <b-field label="Factuurdatum"
                                    :message="getError(errors, 'date')"
                                    :type="getType(errors, 'date', '')"
                                >
                                    <b-datepicker
                                        placeholder="Klik om te selecteren"
                                        :nearby-selectable-month-days="true"
                                        icon="calendar-alt"
                                        icon-pack="fas"
                                        :min-date="moment(new Date()).startOf('day').toDate()"
                                        v-model="record.date"
                                    />
                                </b-field>

                                <br><br>
                            </div>

                            <h5>Producten</h5>
                            <p v-if="type == 'credit'">
                                Geef aan welke bedragen er gewenst zijn om te crediteren. In het borg- en het totaal veld kan je via het vinkje aangeven welk type bedrag er gecrediteerd gaat worden.
                                Bedragen met borg zijn BTW-vrij, bedragen in veld "totaal" worden berekend met BTW.
                            </p>
                            <p v-if="type == 'invoice'">
                                Voeg producten toe voor de factuur. Vul de borg en/of totaal bedragen in. BTW wordt automatisch berekend op basis van het totaal bedrag.
                            </p>

                            <b-notification v-if="record.customer && record.customer.type == 'business' && type != 'credit'" type="is-info" aria-close-label="Sluiten">
                                <strong>Let op:</strong> getoonde prijzen zijn exclusief BTW (zakelijke klant)
                            </b-notification>

                            <b-notification v-if="record.customer && record.customer.type == 'foundation' && type != 'credit'" type="is-info" aria-close-label="Sluiten">
                                <strong>Let op:</strong> klant betreft een stichting, BTW wordt niet getoond op de factuur.
                            </b-notification>

                            <b-table
                                :data="record.products"
                                :striped="true"
                                :loading="loading"
                                :mobile-cards="true"
                                class="deposit-table"
                            >
                                <template>
                                    <b-table-column v-slot="product" field="name" label="Product" width="200">
                                        <b-input v-model="product.row.name"></b-input>
                                    </b-table-column>

                                    <b-table-column v-slot="product" field="btw" label="BTW %" width="100">
                                        <b-input
                                            type="number"
                                            min="0"
                                            max="100"
                                            v-if="product.row.totalType == 'price' || product.row.totalType == 'both'"
                                            v-model="product.row.btw"
                                            :disabled="product.row.totalType == 'deposit'"
                                        ></b-input>
                                    </b-table-column>

                                    <b-table-column v-slot="product" field="name" label="Aantal" width="100">
                                        <b-input type="number" min="1" v-model="product.row.amount"></b-input>
                                    </b-table-column>

                                    <b-table-column v-slot="product" field="deposit" label="Borg" width="100">
                                        <b-field :type="isDepositSelected(product.row) && type == 'credit' ? 'is-success' : 'is-light'">
                                            <b-input
                                                v-model="product.row.deposit"
                                                :icon-right="type == 'credit' ? 'check' : ''"
                                                :icon-right-clickable="type == 'credit'"
                                                min="0"
                                                :custom-class="type == 'credit' ? 'deposit-input' : ''"
                                                validation-message=""
                                                @icon-right-click="type == 'credit' ? toggleDepositSelection(product.row) : null"
                                                @input="type == 'credit' ? onDepositChange(product.row, $event) : null"
                                            />
                                        </b-field>
                                    </b-table-column>

                                    <b-table-column v-slot="product" field="price" label="Totaal" width="100">
                                        <b-field :type="isPriceSelected(product.row) && type == 'credit' ? 'is-success' : 'is-light'">
                                            <b-input
                                                v-model="product.row.price"
                                                :icon-right="type == 'credit' ? 'check' : ''"
                                                :icon-right-clickable="type == 'credit'"
                                                min="0"
                                                validation-message=""
                                                :custom-class="type == 'credit' ? 'deposit-input' : ''"
                                                @icon-right-click="type == 'credit' ? togglePriceSelection(product.row) : null"
                                                @input="type == 'credit' ? onPriceChange(product.row, $event) : null"
                                            />
                                        </b-field>

                                        <!-- <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                                        <span v-else-if="product.row.price > 0">&euro;&nbsp;{{ number_format(product.row.price * (product.row.amount || 1)) }}</span>
                                        <span v-else>-</span> -->
                                    </b-table-column>

                                    <b-table-column v-slot="product" label="Korting" width="100" :visible="type != 'credit'">
                                        <b-button
                                            type="is-info"
                                            icon-left="percent"
                                            @click="openDiscountModal(product.row)"
                                            :outlined="!hasDiscount(product.row.id)"
                                            size="is-small"
                                        >
                                            {{ getDiscountDisplay(product.row) }}
                                        </b-button>
                                    </b-table-column>

                                    <b-table-column v-slot="product" numeric width="0">
                                        <b-tooltip label="Verwijder product uit creditfactuur" position="is-left">
                                            <b-button icon-right="times" type="is-danger" @click="removeProduct(product.row.id)"></b-button>
                                        </b-tooltip>
                                    </b-table-column>
                                </template>
                                <template #footer>
                                    <table class="text-right deposit-table-footer">
                                        <tr>
                                            <th>Subtotaal (ex. BTW)</th>
                                            <th width="150">€&nbsp;{{ !_.isNaN(subTotal) ? number_format(subTotal) : '-' }}</th>
                                        </tr>
                                        <tr>
                                            <th>Inbegrepen BTW:</th>
                                            <th width="150">€&nbsp;{{ !_.isNaN(btwTotal) ? number_format(btwTotal) : '-' }}</th>
                                        </tr>
                                        <tr v-if="totalDiscountAmount > 0" style="color: #d9534f;">
                                            <th>Totale korting:</th>
                                            <th width="150" class="has-text-danger">- €&nbsp;{{ number_format(totalDiscountAmount) }}</th>
                                        </tr>
                                        <tr v-if="record.customer && record.customer.type == 'business'" >
                                            <th class="text-info">Totaal (incl. BTW):</th>
                                            <th width="150" v-if="type == 'credit'" class="has-text-danger">
                                                <span v-show="totalPrice > 0">- </span>€&nbsp;{{ !_.isNaN(totalPrice) ? number_format(totalPrice) : '-' }}
                                            </th>
                                            <th width="150" v-else>€&nbsp;{{ !_.isNaN(totalPrice) ? number_format(totalPrice) : '-' }}</th>
                                        </tr>
                                        <tr v-else>
                                            <th>Totaal:</th>
                                            <th width="150" v-if="type == 'credit'" class="has-text-danger">
                                                <span v-show="totalPrice > 0">- </span>€&nbsp;{{ !_.isNaN(totalPrice) ? number_format(totalPrice) : '-' }}
                                            </th>
                                            <th width="150" v-else>€&nbsp;{{ !_.isNaN(totalPrice) ? number_format(totalPrice) : '-' }}</th>
                                        </tr>
                                    </table>
                                </template>
                            </b-table>

                            <b-button @click="addProduct" type="is-primary" :outlined="type == 'invoice'">Product toevoegen</b-button>
                            <b-button @click="$refs['ContractsRecordProducts_products'].showModal(record.products)" type="is-primary" v-if="type == 'invoice'">Product zoeken</b-button>
                        </b-tab-item>
                    </b-tabs>
                </form>
            </div>
        </div>

        <div class="row">
            <div class="column text-right">
                <div class="formfooter">
                    <b-button
                        type="is-success"
                        :loading="loading === true"
                        @click="++activeStep"
                        v-if="activeStep == 0"
                    >Volgende stap</b-button>
                    <b-button
                        type="is-success"
                        :loading="loading === true"
                        @click="createInvoice"
                        :disabled="!isValid"
                        v-else
                    >Opslaan en sluiten</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import CRUDCustomer from '@/vue/CRUDCustomer'
import FindCustomer from '@/vue/FindCustomer'
import ContractsRecordProducts from '@/vue/contracts/ContractsRecordProducts'
import DiscountModal from '@/vue/discounts/DiscountModal'
import filtersMixin from '@/mixins/filterMixins'
import toastMixins from '@/mixins/toastMixins'
import formvalidationMixin from '@/mixins/formvalidationMixin'

export default {
    name: 'CreateInvoiceRecord',

    mixins: [filtersMixin, toastMixins, formvalidationMixin],

    components: {
        CRUDCustomer,
        FindCustomer,
        ContractsRecordProducts,
        DiscountModal
    },

    data() {
        return {
            type: null,
            updateKey: 0,
            activeStep: 0,
            hideCustomerTab: false,
            mode: 'new',
            record: {
                location: null,
                customer_id: null,
                customer: null,
                products: [],
                organisation: null,
                date: null,
                payment_type: null
            },
            loading: false,
            errors: {},
            showDiscountModal: false,
            currentProductPrice: 0,
            currentProductDiscounts: [],
            currentProductRow: null,
            productDiscounts: {} // Store discounts per product ID

            // canRemoveCustomer: true // replaced
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },

        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },

        isValid() {
            let valid = true

            if(_.isNaN(this.subTotal) || _.isNaN(this.btwTotal) || _.isNaN(this.totalPrice)){
                valid = false
            }
            if(!this.record.products.length){
                valid = false
            }

            return valid
        },

        productsWithDiscountLines() {
            const result = [];

            this.record.products.forEach(product => {
                // Add the product
                result.push(product);

                // Check if this product has a discount
                const discounts = this.productDiscounts[product.id];
                if (discounts && discounts.length > 0 && discounts[0].value > 0) {
                    const discount = discounts[0];
                    const price = parseFloat(product.price) || 0;
                    const amount = product.amount || 1;

                    // Calculate discount amount
                    let discountAmount = 0;
                    if (discount.type === 'percentage') {
                        discountAmount = (price * amount) * (discount.value / 100);
                    } else {
                        discountAmount = Math.min(discount.value * amount, price * amount);
                    }

                    if (discountAmount > 0) {
                        // Add discount line
                        result.push({
                            id: `discount_${product.id}`,
                            name: `Korting: ${discount.type === 'percentage' ? discount.value + '%' : '€' + discount.value}${discount.description ? ' (' + discount.description + ')' : ''}`,
                            isDiscountLine: true,
                            discountAmount: discountAmount,
                            parentProductId: product.id
                        });
                    }
                }
            });

            return result;
        },

        subTotal() {
            if(!_.has(this, 'record.products')) return false;

            let price = 0
            _.each(this.record.products, (product) => {
                const isBusinessCustomer = this.record && _.has(this.record, 'customer') && this.record.customer && this.record.customer.type == 'business'
                const discount = this.getProductDiscountAmount(product);

                if (this.type === 'credit') {
                    // Skip products with no selections for credit invoices
                    if (product.totalType === 'none') return

                    if (product.price && product.btw) {
                        if (isBusinessCustomer) {
                            // For business customers in credit invoices, product.price from database is VAT-inclusive
                            // We need to extract the ex-VAT price for display
                            const priceExVAT = parseFloat(product.price) / (1 + Number(product.btw) / 100);
                            const basePrice = priceExVAT * product.amount;
                            price += basePrice - discount;
                        } else {
                            // For normal customers, extract the ex. BTW price
                            const productTotal = (parseFloat(product.price) / (1 + Number(product.btw) / 100)) * product.amount
                            const discount = this.getProductDiscountAmount(product);
                            price += productTotal - (discount / (1 + Number(product.btw) / 100))
                        }
                    }
                } else {
                    // For regular invoices, always include price (deposit doesn't affect subTotal)
                    if (product.price && product.btw) {
                        if (isBusinessCustomer) {
                            // For business customers, product.price is already ex. BTW
                            const basePrice = parseFloat(product.price) * product.amount;
                            price += basePrice - discount;
                        } else {
                            // For normal customers, extract the ex. BTW price
                            const productTotal = (parseFloat(product.price) / (1 + Number(product.btw) / 100)) * product.amount
                            const discount = this.getProductDiscountAmount(product);
                            price += productTotal - (discount / (1 + Number(product.btw) / 100))
                        }
                    }
                }
            })

            return price
        },

        btwTotal() {
            if(!_.has(this, 'record.products')) return false;
            let price = 0

            _.each(this.record.products, (product) => {
                const isBusinessCustomer = this.record && _.has(this.record, 'customer') && this.record.customer && this.record.customer.type == 'business'
                const discount = this.getProductDiscountAmount(product);

                if(this.type == 'credit') {
                    // Skip products with no selections for credit invoices
                    if (product.totalType === 'none') return

                    // For credit invoices, calculate based on what's actually selected
                    if (product.totalType === 'both') {
                        // Both selected - include price portion only for BTW calculation
                        if (isBusinessCustomer) {
                            // For business customers in credit invoices, product.price from database is VAT-inclusive
                            const priceExVAT = parseFloat(product.price) / (1 + Number(product.btw) / 100);
                            const basePrice = priceExVAT * product.amount;
                            const discountedBase = basePrice - discount;
                            price += (discountedBase * product.btw / 100)
                        } else {
                            // Calculate BTW on the discounted price, not original price minus discount BTW
                            const totalPrice = parseFloat(product.price) * product.amount;
                            const discountedPrice = totalPrice - discount;
                            price += discountedPrice - (discountedPrice / (1 + Number(product.btw) / 100))
                        }
                    } else if (product.totalType === 'price' || this.isPriceSelected(product)) {
                        if (isBusinessCustomer) {
                            // For business customers in credit invoices, product.price from database is VAT-inclusive
                            const priceExVAT = parseFloat(product.price) / (1 + Number(product.btw) / 100);
                            const basePrice = priceExVAT * product.amount;
                            const discountedBase = basePrice - discount;
                            price += (discountedBase * product.btw / 100)
                        } else {
                            // Calculate BTW on the discounted price, not original price minus discount BTW
                            const totalPrice = parseFloat(product.price) * product.amount;
                            const discountedPrice = totalPrice - discount;
                            price += discountedPrice - (discountedPrice / (1 + Number(product.btw) / 100))
                        }
                    }
                    // Deposits don't contribute to BTW calculation
                } else {
                    // Regular invoice logic - always include BTW on price (deposit is BTW-free)
                    if (isBusinessCustomer) {
                        const basePrice = parseFloat(product.price) * product.amount;
                        const discountedBase = basePrice - discount;
                        price += (discountedBase * product.btw / 100)
                    } else {
                        // Calculate BTW on the discounted price, not original price minus discount BTW
                        const totalPrice = parseFloat(product.price) * product.amount;
                        const discountedPrice = totalPrice - discount;
                        price += discountedPrice - (discountedPrice / (1 + Number(product.btw) / 100))
                    }
                }
            })

            return price
        },

        totalPrice() {
            if(!_.has(this, 'record.products')) return false;
            let price = 0

            _.each(this.record.products, (product) => {
                const isBusinessCustomer = this.record && _.has(this.record, 'customer') && this.record.customer && this.record.customer.type == 'business'
                const discount = this.getProductDiscountAmount(product);

                if(this.type == 'credit') {
                    // Skip products with no selections for credit invoices
                    if (product.totalType === 'none') return

                    if (product.totalType === 'both') {
                        // Both selected - include both deposit and price
                        if (isBusinessCustomer) {
                            // For business customers in credit invoices, product.price from database is VAT-inclusive
                            // Just use it directly as it already includes VAT
                            price += (parseFloat(product.price) * product.amount) + (parseFloat(product.deposit) * product.amount) - discount;
                        } else {
                            price += (parseFloat(product.price) * product.amount) + (parseFloat(product.deposit) * product.amount) - discount;
                        }
                    } else if (product.totalType === 'price' || this.isPriceSelected(product)) {
                        if (isBusinessCustomer) {
                            // For business customers in credit invoices, product.price from database is VAT-inclusive
                            // Just use it directly as it already includes VAT
                            price += parseFloat(product.price) * product.amount - discount;
                        } else {
                            price += parseFloat(product.price) * product.amount - discount;
                        }
                    } else if (product.totalType === 'deposit' || this.isDepositSelected(product)) {
                        price += parseFloat(product.deposit) * product.amount
                    }
                } else {
                    // Regular invoice - always include both price and deposit
                    if(isBusinessCustomer){
                        const basePrice = parseFloat(product.price) * product.amount;
                        const discountedBase = basePrice - discount;
                        const btwAmount = discountedBase * product.btw / 100;
                        price += discountedBase + btwAmount + (parseFloat(product.deposit) * product.amount);
                    } else {
                        price += (parseFloat(product.price) * product.amount) + (parseFloat(product.deposit) * product.amount) - discount;
                    }
                }
            })

            return price
        },

        totalDiscountAmount() {
            let total = 0;
            this.record.products.forEach(product => {
                total += this.getProductDiscountAmount(product);
            });
            return total;
        },


    },

    watch: {
        // Force reactivity when product selections change
        'record.products': {
            handler() {
                // Force computed properties to recalculate
                this.$forceUpdate()
            },
            deep: true
        }
    },

    created() {
        if (this.user.organisation) {
            this.record.organisation = this.user.organisation
        }

        // Set default location
        if (
            this.user.organisations &&
            this.user.organisation &&
            this.user.organisations[this.user.organisation] &&
            this.user.organisations[this.user.organisation].default_location_id
        ) {
            this.record.location = this.user.organisations[this.user.organisation].default_location_id;
        } else {
            this.record.location = null;
        }

        if (this.$route.name == 'CreditInvoiceRecord') {
            this.type = 'credit'
            this.fetchInvoiceProducts()

            if (_.has(this.$route.query, 'invoice')){
                this.hideCustomerTab = true // hide customer tab, we dont want you to change this.
            }
            if (_.has(this.$route.query, 'no-reference')){
                this.loading = false
                this.addProduct()
            }
        } else if (this.$route.name == 'CreateInvoiceRecord') {
            this.type = 'invoice'
            this.record.date = moment(new Date()).startOf('day').toDate() // select today

            if ((_.has(this.$route.query, 'type') && this.$route.query.type == 'los')) {
                if (_.has(this.$route.query, 'products')) {
                    // Convert to string and then split
                    const products = String(this.$route.query.products)
                    const productIds = products.split(',')

                    // Initialize empty products array
                    this.$set(this.record, 'products', [])

                    // Fetch each product sequentially
                    productIds.forEach(productId => {
                        this.fetchProduct(productId)
                    })
                } else {
                    // No products to fetch. Add a default one.
                    this.addProduct()
                }
            } else {
                // No products to fetch. Add a default one.
                this.addProduct()
            }
        } else {
            // No products to fetch. Add a default one.
            this.addProduct()
        }

        // Initialize product selections for existing products
        this.$nextTick(() => {
            this.initializeProductSelections()
        })
    },

    mounted() {
        const routeQuery = this.$route.query

        if(Object.keys(routeQuery).length){
            if(_.has(routeQuery, 'customer')){
                this.record.customer_id = routeQuery.customer
                this.activeStep = 1

                this.$refs['CRUDcustomer'].fetchCustomerWithID(parseInt(routeQuery.customer))
            }
        }
    },

    methods: {
        fetchInvoiceProducts() {
            this.loading = true
            const routeQuery = this.$route.query
            if(!routeQuery.invoice) return false;

            const draftParam = routeQuery.draft ? '?draft=true' : ''
            axios.get('/api/invoices/'+routeQuery.invoice + draftParam, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.record.organisation = response.data.organisation
                this.record.location = response.data.location || this.user.organisations[this.user.organisation].default_location_id
                // Preselect customer and move to products tab
                if (response.data.customer) {
                    this.record.customer = response.data.customer
                    this.record.customer_id = response.data.customer.id
                    this.activeStep = 1
                }

                if(_.has(routeQuery, 'products')){
                    // Convert to string and then split (plain IDs only)
                    const products = String(routeQuery.products)
                    const productIds = products.split(',')
                    const depositProducts = []
                    const added = new Set()

                    _.each(productIds, (idToken) => {
                        const idNum = Number(String(idToken).trim())
                        if (!idNum) return

                        let findProduct = _.find(response.data.invoice_products, (x) => { return x.id == idNum })
                        if (!findProduct) {
                            findProduct = _.find(response.data.invoice_products, (x) => { return x.product == idNum })
                        }
                        if (!findProduct) {
                            findProduct = _.find(response.data.contract_products, (x) => { return x.product == idNum })
                        }

                        if (findProduct) {
                            const baseIdentifier = findProduct.id || findProduct.product
                            if (!added.has(baseIdentifier)) {
                                const row = {...findProduct}
                                row.amount = _.isNull(row.amount) ? 1 : row.amount
                                // Auto-set totalType based on available data
                                row.totalType = (parseFloat(row.deposit || 0) > 0) ? 'deposit' : 'price'
                                // Initialize selection array for checkboxes
                                row.selectedTypes = [row.totalType]
                                depositProducts.push(row)
                                added.add(baseIdentifier)
                            }
                        }
                    })

                    this.$set(this.record, 'products', [...depositProducts])
                    // Initialize selections for loaded products
                    this.$nextTick(() => this.initializeProductSelections())
                } else {
                    // Use draft/record invoice products directly
                    const uniqueProducts = _.uniqBy(response.data.invoice_products, 'id')
                    this.$set(this.record, 'products', uniqueProducts)
                    this.activeStep = 1
                    // Initialize selections for loaded products
                    this.$nextTick(() => this.initializeProductSelections())
                }
            }).catch((error) => {
                console.log(error)
                this.showError('Daar gaat iets fout! Probeer het opnieuw.')
                this.$router.go(-1)
            }).then(() => {
                this.loading = false
            })
        },

        fetchProduct(id = false) {
            id = id || this.$route.query.product
            if (!id) return false

            this.loading = true

            axios.get('/api/products/'+id, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                let products = [...this.record.products] // Create a copy of existing products
                this.record.organisation = response.data.organisation
                this.record.location = response.data.location || this.user.organisations[this.user.organisation].default_location_id

                _.assign(response.data, {
                    amount: 1,
                    type: 'product',
                    contract: null,
                    once: 1,
                    product: response.data.id,
                    totalType: (parseFloat(response.data.deposit || 0) > 0) ? 'deposit' : 'price'
                })
                response.data.selectedTypes = [response.data.totalType]

                products.push(response.data)
                this.$set(this.record, 'products', products)
            }).catch((error) => {
                this.showError('Daar gaat iets fout! Probeer het opnieuw.')
                this.$router.go(-1)
            }).then(() => {
                this.loading = false
            })
        },

        passProducts(obj) {
            // Remove first product if it has no name and zero price to get replaced by a new relevant product.
            if (obj.records.length > 0 &&
                (!obj.records[0].name?.length) &&
                obj.records[0].price === '0.00') {
                obj.records.shift()
            }

            // Map products directly instead of mutating with _.each
            const products = obj.records.map(product => {
                const newProduct = {
                    ...product,
                    amount: product.amount || 1,
                    type: 'product',
                    contract: null,
                    once: 1,
                    product: product.id,
                    totalType: (parseFloat(product.deposit || 0) > 0) ? 'deposit' : 'price'
                }
                newProduct.selectedTypes = [newProduct.totalType]
                return newProduct
            })

            this.$set(this.record, 'products', products)
        },

        removeProduct(productId){
            const products =_.remove(this.record.products, (x) => {
                return x.id != productId
            })

            this.$set(this.record, 'products', products)
        },

        createInvoice() {
            // If we are editing a draft creditinvoice, finalize instead of creating a new one
            if (this.$route.query && this.$route.query.draft && this.$route.query.invoice && this.type === 'credit') {
                // Process products the same way as regular invoice creation
                let theProducts = _.filter(this.record.products, (x) => {
                    return !!x.name.length && x.totalType !== 'none'
                })

                if(!theProducts.length){
                    this.showError('Geen producten geselecteerd. Selecteer minimaal één product om door te gaan.')
                    return;
                }

                // Handle dual selection (both deposit and price selected)
                const processedProducts = []
                _.each(theProducts, (product) => {
                    if (product.totalType === 'both') {
                        // Create separate products only for non-zero values
                        if (parseFloat(product.deposit || 0) > 0) {
                            const depositProduct = {
                                ...product,
                                totalType: 'deposit',
                                price: 0, // Only deposit for this line
                                organisation: this.record.organisation
                            }
                            processedProducts.push(depositProduct)
                        }
                        if (parseFloat(product.price || 0) > 0) {
                            const priceProduct = {
                                ...product,
                                totalType: 'price',
                                deposit: 0, // Only price for this line
                                organisation: this.record.organisation
                            }
                            processedProducts.push(priceProduct)
                        }
                    // Note: products with totalType === 'none' are already filtered out above
                    } else {
                        // Single selection - only add if the selected type has a value > 0
                        const shouldInclude =
                            (product.totalType === 'deposit' && parseFloat(product.deposit || 0) > 0) ||
                            (product.totalType === 'price' && parseFloat(product.price || 0) > 0)

                        if (shouldInclude) {
                            processedProducts.push({
                                ...product,
                                organisation: this.record.organisation
                            })
                        }
                    }
                })

                this.loading = true
                console.log('Finalizing credit draft with products:', processedProducts)
                axios.post(`/api/credit-invoice/draft/${this.$route.query.invoice}/finalize`, {
                    products: processedProducts
                }, {
                    headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
                }).then((response) => {
                    const id = _.get(response, 'data.id') || this.$route.query.invoice
                    this.$router.push({ name: 'InvoicesRecord', params: { type: 'credit', id } })
                }).catch((error) => {
                    if (_.has(error, 'response.data.error') && error.response.data.error == 'already-finalized'){
                        this.showError('Deze creditfactuur is al gemaakt.')
                        this.loading = false
                        return
                    }

                    const msg = _.get(error, 'response.data.error') || 'Finaliseren mislukt'
                    this.$buefy.toast.open({ message: msg, type: 'is-danger' })
                    this.loading = false
                })
                return
            }

            if(_.isNull(this.record.customer_id) || !_.has(this.record, 'customer_id')){
                this.showError('Er is geen klant gekoppeld.')
                this.activeStep = 0
                return false;
            }

            this.loading = true

            // Has this invoice a credit_of?
            this.record.credit_of = _.has(this.$route.query, 'invoice') ? this.$route.query.invoice : null

            // Slice out products without a name and products with no selection
            let theProducts = _.filter(this.record.products, (x) => {
                return !!x.name.length && x.totalType !== 'none'
            })

            if(!theProducts.length){
                this.showError('Geen producten geselecteerd. Selecteer minimaal één product om door te gaan.')
                this.loading = false
                return;
            }

            // Handle dual selection (both deposit and price selected)
            const processedProducts = []
            _.each(theProducts, (product) => {
                if (product.totalType === 'both') {
                    // Create separate products only for non-zero values
                    if (parseFloat(product.deposit || 0) > 0) {
                        const depositProduct = {
                            ...product,
                            totalType: 'deposit',
                            price: 0, // Only deposit for this line
                            organisation: this.record.organisation
                        }
                        processedProducts.push(depositProduct)
                    }
                    if (parseFloat(product.price || 0) > 0) {
                        const priceProduct = {
                            ...product,
                            totalType: 'price',
                            deposit: 0, // Only price for this line
                            organisation: this.record.organisation
                        }
                        processedProducts.push(priceProduct)
                    }
                // Note: products with totalType === 'none' are already filtered out above
                } else {
                    // Single selection - only add if the selected type has a value > 0
                    const shouldInclude =
                        (product.totalType === 'deposit' && parseFloat(product.deposit || 0) > 0) ||
                        (product.totalType === 'price' && parseFloat(product.price || 0) > 0)

                    if (shouldInclude) {
                        processedProducts.push({
                            ...product,
                            organisation: this.record.organisation
                        })
                    }
                }
            })

            theProducts = processedProducts

            // Apply discounts to products
            theProducts = theProducts.map(product => {
                const discounts = this.productDiscounts[product.id]
                if (discounts && discounts.length > 0) {
                    return {
                        ...product,
                        discount_type: discounts[0].type,
                        discount_value: discounts[0].value,
                        discount_description: discounts[0].description || null
                    }
                }
                return product
            })

            this.record.products = theProducts

            if(!theProducts.length){
                this.showError('Maak producten met een prijs aan om de factuur aan te maken.')
                this.loading = false
                this.addProduct()
                return
            }

            axios.post('/api/generate-invoice/'+this.type, this.record, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                if(response.data.id){
                    this.$router.push({name: 'InvoicesRecord', params: {type: this.type, id: response.data.id}})
                }
            }).catch((error) => {
                if(_.has(error, 'response.data.error') && error.response.data.error == 'not-org-admin'){
                    this.showError('Opslaan niet mogelijk, enkel een administrator is gemachtigd om deze gegevens aan te passen.')
                } else if (_.has(error, 'response.data.error')){
                    this.showError('Opslaan mislukt - ' + error.response.data.error, 5000)
                } else {
                    this.$buefy.toast.open({
                        message: 'Opslaan mislukt - Onvoldoende of onjuiste gegevens.',
                        type: 'is-danger'
                    })
                }

                console.error('[❌] Error while validating the product:', error)
                this.errors = {...error.response.data.errors}
                this.loading = false
            }).then(() => {
                this.loading = false
            })
        },

        addProduct(){
            const product = {
                id: Math.floor(100000000 + Math.random() * 900000000),// random to delete
                amount: 1,
                btw: '21.00',
                deposit: '0.00',
                name: '',
                price: '0.00',
                once: 1,
                organisation: this.record.organisation,
                type: 'product',
                product: null,
                totalType: (parseFloat('0.00') > 0) ? 'deposit' : 'price' // Will be 'price' for new products
            }

            // Only set selectedTypes for credit invoices
            if (this.type === 'credit') {
                product.selectedTypes = [product.totalType]
            }

            this.record.products.push(product)
        },

        openDiscountModal(row) {
            this.currentProductRow = row
            this.currentProductPrice = parseFloat(row.price) || 0
            this.currentProductDiscounts = this.productDiscounts[row.id] || []
            this.showDiscountModal = true
        },

        applyDiscount(discountsData) {
            if (this.currentProductRow) {
                // Store discount for this product
                Vue.set(this.productDiscounts, this.currentProductRow.id, discountsData.discounts || [])
                console.log('Applied discount to product:', this.currentProductRow.id, discountsData)
                console.log('All product discounts:', this.productDiscounts)
                // Force re-render
                this.$forceUpdate()
            }
            this.showDiscountModal = false
        },

        removeDiscount() {
            if (this.currentProductRow) {
                Vue.delete(this.productDiscounts, this.currentProductRow.id)
            }
            this.showDiscountModal = false
        },

        hasDiscount(productId) {
            return this.productDiscounts[productId] && this.productDiscounts[productId].length > 0
        },

        getDiscountDisplay(row) {
            const discounts = this.productDiscounts[row.id]

            if (!discounts || discounts.length === 0) {
                return 'Korting'
            }

            const discount = discounts[0] // Only one discount in single invoice mode
            if (discount.type === 'percentage') {
                return `${discount.value}%`
            }
            return `€${discount.value}`
        },

        getProductDiscountAmount(product) {
            const discounts = this.productDiscounts[product.id];
            if (!discounts || discounts.length === 0 || !discounts[0].value) {
                return 0;
            }

            const discount = discounts[0];
            const price = parseFloat(product.price) || 0;
            const amount = product.amount || 1;

            if (discount.type === 'percentage') {
                return (price * amount) * (discount.value / 100);
            } else {
                return Math.min(discount.value * amount, price * amount);
            }
        },

                        // Selection methods for dual deposit/price selection
        isDepositSelected(product) {
            const selected = product.selectedTypes?.includes('deposit') ||
                           (product.totalType === 'deposit' && !product.selectedTypes)
            return selected
        },

        isPriceSelected(product) {
            const selected = product.selectedTypes?.includes('price') ||
                           (product.totalType === 'price' && !product.selectedTypes)
            return selected
        },

                        toggleDepositSelection(product) {
            if (!product.selectedTypes) {
                this.$set(product, 'selectedTypes', [product.totalType])
            }

            const index = product.selectedTypes.indexOf('deposit')
            if (index > -1) {
                // Remove deposit selection
                product.selectedTypes.splice(index, 1)
            } else {
                // Add deposit selection
                product.selectedTypes.push('deposit')
            }

            console.log('Toggled deposit for product:', product.name, 'selectedTypes:', product.selectedTypes)
            this.updateProductTotalType(product)
            // Force reactivity for totals
            this.$nextTick(() => this.$forceUpdate())
        },

                        togglePriceSelection(product) {
            if (!product.selectedTypes) {
                this.$set(product, 'selectedTypes', [product.totalType])
            }

            const index = product.selectedTypes.indexOf('price')
            if (index > -1) {
                // Remove price selection
                product.selectedTypes.splice(index, 1)
            } else {
                // Add price selection
                product.selectedTypes.push('price')
            }

            console.log('Toggled price for product:', product.name, 'selectedTypes:', product.selectedTypes)
            this.updateProductTotalType(product)
            // Force reactivity for totals
            this.$nextTick(() => this.$forceUpdate())
        },

                        updateProductTotalType(product) {
            const selectedTypes = product.selectedTypes || []

            if (selectedTypes.length === 0) {
                // No selections - mark as none selected (will be excluded from invoice)
                product.totalType = 'none'
            } else if (selectedTypes.length === 1) {
                // Single selection
                product.totalType = selectedTypes[0]
            } else if (selectedTypes.length === 2) {
                // Both selected - we'll handle duplication during save
                product.totalType = 'both' // Special marker for dual selection
            }
        },

        // Auto-select/deselect based on field value changes
                onDepositChange(product, value) {
            if (!product.selectedTypes) {
                this.$set(product, 'selectedTypes', [])
            }

            const hasValue = parseFloat(value || 0) > 0
            const isSelected = product.selectedTypes.includes('deposit')

            if (hasValue && !isSelected) {
                // Auto-select when value is added
                product.selectedTypes.push('deposit')
                console.log('Auto-selected deposit for:', product.name)
            } else if (!hasValue && isSelected) {
                // Auto-deselect when value is removed/zero
                const index = product.selectedTypes.indexOf('deposit')
                product.selectedTypes.splice(index, 1)
                console.log('Auto-deselected deposit for:', product.name)
            }

            this.updateProductTotalType(product)
            // Force reactivity for totals
            this.$nextTick(() => this.$forceUpdate())
        },

                onPriceChange(product, value) {
            if (!product.selectedTypes) {
                this.$set(product, 'selectedTypes', [])
            }

            const hasValue = parseFloat(value || 0) > 0
            const isSelected = product.selectedTypes.includes('price')

            if (hasValue && !isSelected) {
                // Auto-select when value is added
                product.selectedTypes.push('price')
                console.log('Auto-selected price for:', product.name)
            } else if (!hasValue && isSelected) {
                // Auto-deselect when value is removed/zero
                const index = product.selectedTypes.indexOf('price')
                product.selectedTypes.splice(index, 1)
                console.log('Auto-deselected price for:', product.name)
            }

            this.updateProductTotalType(product)
            // Force reactivity for totals
            this.$nextTick(() => this.$forceUpdate())
        },

        // Ensure all products have proper initialization
        initializeProductSelections() {
            if (this.record && this.record.products && this.type === 'credit') {
                this.record.products.forEach(product => {
                    if (!product.selectedTypes) {
                        const defaultType = (parseFloat(product.deposit || 0) > 0) ? 'deposit' : 'price'
                        this.$set(product, 'totalType', product.totalType || defaultType)
                        this.$set(product, 'selectedTypes', [product.totalType])
                    }
                })
            }
        },

        linkCustomer(customer){
            if(!customer) return

            Vue.set(this.record, 'customer', {...customer})
            Vue.set(this.record, 'customer_id', customer.id)
            Vue.set(this.record, 'organisation', customer.organisation)
        },

        removeCustomer(){
            Vue.set(this.record, 'customer_id', null)
            Vue.set(this.record, 'customer', null)
            Vue.set(this.record, 'organisation', null)

            this.$refs.findCustomer.searchCustomer()
        },

        fullPageLoader(value){
            this.loading = value
        },

        number_format(val, decimals = 2) {
            val = parseFloat(val)
            return val.toFixed(decimals)
        },
    }
}
</script>
